import { createReducer, createAction } from '@reduxjs/toolkit';

export const loginRequest = createAction('LoginRequest');
export const loginSuccess = createAction('loginSuccess');
export const loginFailure = createAction('loginFailure');
export const logoutUserRequest = createAction('LogoutUserRequest');
export const logoutUserSuccess = createAction('LogoutUserSuccess');
export const logoutUserFailure = createAction('LogoutUserFailure');

// New actions for registration
export const registerRequest = createAction('RegisterRequest');
export const registerSuccess = createAction('RegisterSuccess');
export const registerFailure = createAction('RegisterFailure');

const initialState = {
  loading: false,
  user: null,
  error: null,
  isAuthenticated: false,
};

export const userReducer = createReducer(initialState, (builder) => {
  builder
    // Login cases
    .addCase(loginRequest, (state) => {
      state.loading = true;
    })
    .addCase(loginSuccess, (state, action) => {
      state.loading = false;
      state.user = action.payload;
      state.isAuthenticated = true;
      state.error = null;
    })
    .addCase(loginFailure, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = false;
    })
    // Logout cases
    .addCase(logoutUserRequest, (state) => {
      state.loading = true;
    })
    .addCase(logoutUserSuccess, (state) => {
      state.loading = false;
      state.user = null;
      state.isAuthenticated = false;
    })
    .addCase(logoutUserFailure, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.isAuthenticated = true;
    });
});
